import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink } from "@angular/router";
import { SharedMaterialModule } from "../../shared-material.module";

/**
 * Friendly empty-state CTA shown instead of feature content whenever a
 * logged-in user hasn't connected their Notion workspace yet (or the
 * connection check failed). Used by /competition (backlog #153) and /duel,
 * replacing the previous alert()+redirect pattern on both pages.
 */
@Component({
  selector: "app-connect-notion-cta",
  imports: [SharedMaterialModule, RouterLink],
  templateUrl: "./connect-notion-cta.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./connect-notion-cta.component.scss"],
})
export class ConnectNotionCtaComponent {
  @Input() message =
    "Competitions sync your habit data from Notion — connect your workspace to join or create one.";
}
